import React from "react";
import PropTypes from "prop-types";

export default function SnackBar({ active, contentText, buttonText, onClose, contentClassName, buttonClassName }) {
  let element = <div></div>;
  if (active) {
    return (
      <div className='snackbar active notification_message'>
        {
          buttonText && (
            <div className="controls">
              <button
                className={buttonClassName ? `link close ${buttonClassName}` : 'link close' }
                onClick={ onClose }
                dangerouslySetInnerHTML={{__html: buttonText}}
              >
              </button>
            </div>
          )}
        <div className={ contentClassName ? `content ${contentClassName}` : 'content'} >{ contentText }</div>
      </div>
    );
  } else {
    return element;
  }

}

SnackBar.propTypes = {
  active: PropTypes.bool,
  contentText: PropTypes.string,
  buttonText: PropTypes.string,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
  buttonClassName: PropTypes.string
};
